(function () {
  function initAccordion(root) {
    var triggers = Array.prototype.slice.call(
      root.querySelectorAll('[data-accordion-trigger]')
    );

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var panelId = trigger.getAttribute('aria-controls');
        var panel = document.getElementById(panelId);

        trigger.setAttribute('aria-expanded', String(!expanded));
        if (panel) {
          panel.setAttribute('data-open', String(!expanded));
        }
      });
    });
  }

  /* --------------------------------------------------------------------
     Ajout au panier réel (même logique que la section Comparatif offres) :
     API standard Shopify /cart/add.js, puis redirection vers /cart.
     -------------------------------------------------------------------- */
  function getCartAddUrl() {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      '/';
    return root.replace(/\/?$/, '/') + 'cart/add.js';
  }

  function getCartUrl() {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      '/';
    return root.replace(/\/?$/, '/') + 'cart';
  }

  function handleAddToCart(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var label = button.querySelector('.program__cta-button-label');
    var originalText = label ? label.textContent : '';

    button.disabled = true;
    if (label) label.textContent = 'Ajout en cours…';

    fetch(getCartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
      }),
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error(err.description || 'Erreur lors de l’ajout au panier');
          });
        }
        return response.json();
      })
      .then(function () {
        window.location.href = getCartUrl();
      })
      .catch(function (error) {
        button.disabled = false;
        if (label) label.textContent = originalText;
        // eslint-disable-next-line no-alert
        alert(
          'Une erreur est survenue : ' +
            error.message +
            '. Merci de réessayer.'
        );
      });
  }

  function initAddToCart() {
    var buttons = document.querySelectorAll('.program [data-add-to-cart]');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        handleAddToCart(button);
      });
    });
  }

  function initAll() {
    var accordions = document.querySelectorAll('[data-accordion]');
    accordions.forEach(initAccordion);
    initAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();